import React, { ComponentProps } from 'react';
import {
  DatePickerContainer,
  DatePickerInput,
  DatePickerLabel,
} from './DatePicker.styles';

export type TimePickerProps = Omit<
  ComponentProps<typeof DatePickerInput>,
  'type' | 'marginTop' | 'emptyValue'
> & {
  label?: string;
  width?: string;
  error?: boolean;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export const TimePicker = ({
  label,
  width,
  step = 60,
  ...props
}: TimePickerProps) => {
  return (
    <DatePickerContainer marginTop={Boolean(label)} width={width}>
      {label && <DatePickerLabel htmlFor={props.id}>{label}</DatePickerLabel>}
      <DatePickerInput
        type="time"
        step={step}
        marginTop={Boolean(label)}
        emptyValue={props.value === ''}
        {...props}
      />
    </DatePickerContainer>
  );
};
